import { _isNotBlank } from '@/littledash';

export const PAGE_TITLE_BRAND = 'Benchling In Vivo';

/** Formats a page-specific label with the product brand. */
export const formatPageTitle = (title?: string): string =>
  _isNotBlank(title) ? `${title} | ${PAGE_TITLE_BRAND}` : PAGE_TITLE_BRAND;

interface StudyTitleDetails {
  code?: string;
  name?: string;
}

/** Builds a study route label, preferring its code and retaining a useful loading fallback. */
export const buildStudyPageTitle = (study: StudyTitleDetails | undefined, sectionTitle: string): string => {
  const studyCode = study?.code;
  const studyTitle = _isNotBlank(studyCode) ? studyCode : study?.name;
  if (!_isNotBlank(studyTitle)) {
    return sectionTitle;
  }
  return _isNotBlank(sectionTitle) ? `${studyTitle} - ${sectionTitle}` : studyTitle;
};
